import * as Yup from "yup";

export const AddDPGFSchema = Yup.object().shape({
	unit : Yup.string().required("La référence est obligatoire"),
	content : Yup.string(),
	total : Yup.number().required("Le total est obligatoire"),
	vta : Yup.number().min(0, "Le minimum est 0").max(1, "Le maximum est 1").required("Le taux de TVA est obligatoire"),
	cctpIri : Yup.string().required("Le CCTP est obligatoire"),
})